import { Component, OnInit ,Input} from '@angular/core';
import { AngularDelegate } from '@ionic/angular';
import {ModalController} from '@ionic/angular';
import { AppConfigService } from '../app-config.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})

export class AboutComponent implements OnInit {

  
  constructor(private modalCntrl:ModalController,public appConfig:AppConfigService) { }
/*
  track:string,
  name:string,
  lib:string,
  dualName:string;
  dualLib:string;
  dualRelativeVol:number;
  sustain:number;
  effects:any[];

*/
  ngOnInit() {
   
  }



done()

{
  
  this.modalCntrl.dismiss();
};

}